<template>
  <div class="news-set" v-if="notification.dataList && notification.dataList.length">
    <a-dropdown placement="bottomRight">
      <div>
        <a-badge
          :count="notification.noReadCount"
          :overflow-count="maxCount"
          :offset="[(`${notification.noReadCount > maxCount ? (maxCount + 1) : notification.noReadCount}`.length - 1) * 2, 0]"
          :number-style="{
            height: '16px',
            lineHeight: '16px',
            fontSize: '12px',
            padding: '0 5px',
            boxShadow: '0 0 0 1px transparent',
          }"
        >
          <icon-font class="icon" type="gb-icon-notice"></icon-font>
        </a-badge>
      </div>
      <div slot="overlay" class="news-menu">
        <div class="news-menu-title">
          {{langCodeLabels[currentLang].title }}
        </div>
        <div class="news-menu-item" v-for="(item, index) in notification.dataList" :key="index"  @click="toDetails(item)">
          <div class="news-menu-item-top">
            <div class="news-menu-item-top__label" v-if="msgTypeList[item.msgType]">{{ msgTypeList[item.msgType][langCodes[currentLang]]}}</div>
            <div class="news-menu-item-top__time">
              <a-icon type="clock-circle" style="margin-right:3px; font-size: 12px; color:#444444" />
              {{moment(item.sendTime || item.createTime).format('YYYY-MM-DD HH:mm:ss')}}
            </div>
          </div>
          <div class="news-menu-item-info" :title="item.msgTitle">
            {{item.msgTitle}}
          </div>
        </div>
        <div class="news-menu-more">
          <a-button type="link" style="font-size: 12px" @click="toDetails()">
            {{langCodeLabels[currentLang].more }}
          </a-button>
        </div>
      </div>
    </a-dropdown>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  data () {
    const msgTypeList = {
      1: {
        cn: '系统消息',
        en: 'System Information',
        kr: '시스템 정보'
      },
      2: {
        cn: '用量提醒',
        en: 'Usage Reminder',
        kr: '사용 알림'
      },
      3: {
        cn: '直播提醒',
        en: 'Live Broadcast Reminder',
        kr: '라이브 방송 알림'
      },
      4: {
        cn: '过期提醒',
        en: 'Overdue Reminder',
        kr: '기한이 지난 알림'
      },
      5: {
        cn: '活动消息',
        en: 'Event News',
        kr: '이벤트 뉴스'
      }
    }
    return {
      langCodes: {
        en_US: 'en',
        zh_CN: 'cn',
        ko_KR: 'kr'
      },
      langCodeLabels: {
        zh_CN: {
          more: '查看更多 >',
          title: '消息通知'
        },
        en_US: {
          more: 'View more >',
          title: 'Notification'
        },
        ko_KR: {
          more: '더보기 >',
          title: '공고'
        }
      },
      msgTypeList,
      maxCount: 99
    }
  },
  computed: {
    ...mapGetters([
      'currentLang',
      'notification'
    ])
  },
  methods: {
    moment,
    toDetails (row) {
      // window.location.href = '/#/company/notice/notification/details?id=' + row.id
      // window.open('/#/company/notice/notification/details?id=' + row.id)
      console.log('-------')
      let id = ``
      if (row?.id) {
        id = `?id=${row.id}`
      }
      const { params: { serviceId, systemCode } } = this.$route
        this.$store.dispatch('entry/SetActiveAsync', {
          menuName: {
            zh_CN: '消息列表',
            en_US: 'Message list',
            ko_KR: '메시지 목록'
          },
          path: `/entry/${serviceId}/${systemCode}/sso-web#/embel/notification${id}`
          // key: id ? `note${row.id}` : undefined
          // key: undefined
        })
        // window.open(`/#/company/notice/notification${id ? `/details${id}` : ''}`)
      setTimeout(() => {
        this.$store.dispatch('queryMsgNoticePage')
      }, 100)
    }
  },
  mounted () {
    this.$store.dispatch('queryMsgNoticePage')
  }
}
</script>

<style lang="less" scoped>
.news-set {
  color: #fff;
  min-width: 50px;
  text-align: center;
  .icon {
    font-size: 16px;
    display: inline-block;
    cursor: pointer;
    color: #fff;
    opacity: 1;
  }
  &:hover {
    background: rgba(255,255,255,.25);
    color: #40a9ff;
  }
}
.news-menu {
  width: 335px;
  min-height: 50px;
  background: #fff;
  box-shadow: 0px 0px 51px 3px rgba(0, 21, 41, 0.11);
  border-radius: 4px;
  &-title {
    line-height: 42px;
    padding: 0 17px;
    font-size: 14px;
    border-bottom: 1px solid #ECECEC;
  }
  &-item {
    padding: 0 17px 14px 17px;
    width: auto;
    border-bottom: 1px solid #ECECEC;
    font-size: 12px;
    &-top {
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      line-height: 1;
      & * {
        display: inline-flex;
        align-self: center
      }
      &__label {
        padding: 5px 9px;
        background: #E6F0FE;;
        border: 1px solid #CCE2FE;
        border-radius: 2px;
        color: #333333;
      }
    }
    &-info {
      line-height: 18px;
      color: #006EFF;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      &:hover {
        opacity: 0.8;
      }
    }
    &:hover {
      background: rgba(0, 110, 255, 0.05);
      cursor: pointer;
    }
  }
  &-more {
    line-height: 34px;
    padding: 0 17px 0 0;
  }
}
</style>
